import type { ReactNode } from "react";
import { Bot, Wrench, Hash } from "lucide-react";
import { StepInfoRow } from "../../StepInfoRow";
import { getString, getNumber } from "../helpers";
import type { SummaryTranslator } from "../types";

export function getAgentTaskSummary(config: Record<string, unknown>, t: SummaryTranslator): ReactNode[] {
  const items: ReactNode[] = [];

  const modelId = getString(config.model_id);
  const modelDisplay = getString(config.model_display);
  const systemPrompt = getString(config.system_prompt);
  const maxIterations = getNumber(config.max_iterations);
  const toolCount = Array.isArray(config.tools) ? config.tools.length : 0;
  const knowledgeCount = Array.isArray(config.knowledge_ids) ? config.knowledge_ids.length : 0;

  if (modelId) {
    items.push(
      <StepInfoRow
        key="model"
        icon={<Bot className="size-3.5" />}
        label={t("summaries.agent_task.label_model")}
        value={modelDisplay || t("summaries.shared.unknown_reference")}
      />
    );
  }

  if (systemPrompt) {
    const preview = systemPrompt.length > 70 ? systemPrompt.slice(0, 70) + "…" : systemPrompt;
    items.push(
      <StepInfoRow
        key="prompt"
        icon={<Hash className="size-3.5" />}
        label={t("summaries.agent_task.label_system_prompt")}
        value={preview}
      />
    );
  }

  if (maxIterations) {
    items.push(
      <StepInfoRow
        key="iter"
        icon={<Hash className="size-3.5" />}
        label={t("summaries.agent_task.label_max_iter")}
        value={t("summaries.agent_task.iterations_value", { count: maxIterations })}
        mono
      />
    );
  }

  if (toolCount > 0) {
    items.push(
      <StepInfoRow
        key="tools"
        icon={<Wrench className="size-3.5" />}
        label={t("summaries.agent_task.label_tools")}
        value={t("summaries.agent_task.tools_count", { count: toolCount })}
      />
    );
  }

  if (knowledgeCount > 0) {
    items.push(
      <StepInfoRow
        key="kb"
        icon={<Hash className="size-3.5" />}
        label={t("summaries.agent_task.label_knowledge")}
        value={t("summaries.agent_task.knowledge_count", { count: knowledgeCount })}
      />
    );
  }

  return items;
}
